export const tabs = [
  { label: 'Home', value: 'home' },
  { label: 'Containers', value: 'containers' },
  { label: 'Shipments', value: 'shipments' },
  { label: 'Emails', value: 'emails' },
  { label: 'Notes', value: 'notes' },
  { label: 'Shared Contacts', value: 'shared-contact' },
  { label: 'Shared With', value: 'shared-with' },
]
